import { BaseErrorUtility } from "../core/baseUtility";
import type { MappedHttpRequest, SendErrorResponse } from "../core/types";
import type { APIGatewayEventCommon } from "./types";

export class LambdaErrorUtility extends BaseErrorUtility<APIGatewayEventCommon> {
	protected mapRequest(
		request: APIGatewayEventCommon,
	): MappedHttpRequest | Promise<MappedHttpRequest> {
		const method = request.httpMethod ?? null;
		const url = request.path ?? null;
		const query = Object.keys(request.queryStringParameters ?? {}).length
			? request.queryStringParameters!
			: null;

		return {
			method,
			url,
			requestBody: request.body,
			query,
			headers: request.headers ?? null,
		};
	}

	sendErrorFromEndPoint = async (
		error: unknown,
		request: APIGatewayEventCommon,
		userContext?: Record<string, unknown> | undefined,
	): Promise<SendErrorResponse> => {
		return super.sendErrorFromEndPoint(error, request, userContext);
	};
}
